import { Account } from './types';

export function isOrganizationView(
  activeTenantId: string | undefined,
  accounts: Account[] | undefined
): boolean {
  if (!activeTenantId || !accounts || accounts.length === 0) {
    return false;
  }

  const activeAccount = accounts.find((a) => a.accountId === activeTenantId);

  const isSelfReferencingRoot = activeAccount?.accountId === activeAccount?.parentAccountId;

  const hasChildren = accounts.some(
    (a) => a.parentAccountId === activeTenantId && a.accountId !== activeTenantId
  );

  return Boolean(isSelfReferencingRoot || hasChildren);
}

export function getOrganizationAccounts(
  activeTenantId: string | undefined,
  accounts: Account[] | undefined,
  isOrgView: boolean
): Account[] {
  if (!isOrgView || !activeTenantId || !accounts) {
    return [];
  }

  return accounts.filter(
    (acc) => acc.accountId === activeTenantId || acc.parentAccountId === activeTenantId
  );
}
